import he from 'he';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing, withHandlers, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { attachFullNameAndRemoveParent } from '../../../../services';
import { businessActions, businessSelector } from '../../../../state/modules/business';
import { industryActions } from '../../../../state/modules/industry';
import { currentUserIndustry } from '../../../../state/modules/user';
import ContentDetails from './../../shared/publish-content/content-details';

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  includeTasa: fp.filter(industry => industry.includeTasa)(currentUserIndustry(state)).length > 0,
  selectedContent: state.business.content.selectedContent,
  contentQuestions: state.business.content.contentQuestions,
  contentError: state.business.content.error,
  libraryRouteRoot: routes.app.library,
  isFetchingContent: state.business.content.isFetching,
  choosePublisher: false,
  cpdCategorys: fp.map(
    aoa => ({ ...aoa, name: he.decode(aoa.name) })
  )(state.industry.cpdCategorys),
  isFetchingCpdCategorys: state.industry.isFetching,
  industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys,
  isFetchingIndustries: state.industry.isFetchingIndustries,
  contentPassedUserEmails: state.business.content.contentPassedUserEmails
});

const mapDispatchToProps = (dispatch) => ({
  businessLibraryGetContent: bindActionCreators(businessActions.business.content.getById, dispatch),
  businessLibraryResetSelectedContent: bindActionCreators(businessActions.business.content.resetSelectedContent, dispatch),
  businessLibraryGetContentQuestions: bindActionCreators(businessActions.business.content.getContentQuestions, dispatch),
  businessLibraryDeleteContent: bindActionCreators(businessActions.business.content.deleteContent, dispatch),
  businessLibrarySaveContent: bindActionCreators(businessActions.business.content.saveContent, dispatch),
  businessLibraryGetContentPassedUserEmails: bindActionCreators(businessActions.business.content.getContentPassedUserEmails, dispatch),
  getIndustriesWithCpdCategorys: bindActionCreators(industryActions.industries.industriesWithCpdCategorys, dispatch),
  getCpdCategorys: bindActionCreators(industryActions.industries.getCpdCategorys, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderNothing
  ),
  withHandlers({
    getContent: ({ business, businessLibraryGetContent }) => (contentId) => {
      businessLibraryGetContent(business.id, contentId)
    },
    resetSelectedContent: ({ business, businessLibraryResetSelectedContent }) => () => {
      businessLibraryResetSelectedContent(business.id)
    },
    getContentQuestions: ({ business, businessLibraryGetContentQuestions }) => (contentId) => {
      businessLibraryGetContentQuestions(business.id, contentId)
    },
    deleteContent: ({ business, businessLibraryDeleteContentQuestion }) => (contentId, query) => {
      businessLibraryDeleteContentQuestion(business.id, contentId, query)
    },
    saveContent: ({ business, businessLibrarySaveContent }) => (content, nextRoute) => {
      businessLibrarySaveContent(business.id, content, nextRoute)
    },
    getContentPassedUserEmails: ({ business, businessLibraryGetContentPassedUserEmails }) => (contentId) => {
      businessLibraryGetContentPassedUserEmails(business.id, contentId)
    }
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.cpdCategorys.length === 0 && !this.props.isFetchingCpdCategorys) {
        this.props.getCpdCategorys();
      }

      if (this.props.industriesWithCpdCategorys.length === 0 && !this.props.isFetchingIndustries) {
        this.props.getIndustriesWithCpdCategorys()
      }
    }
  }),
  withProps(({
    cpdCategorys
  }) => ({
    cpdCategorys: attachFullNameAndRemoveParent(cpdCategorys)
  }))
)(ContentDetails);


// WEBPACK FOOTER //
// ./src/containers/pages/app/business-library/content-details.js